import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-bookmark',
  templateUrl: './icon-bookmark.component.html',
  styleUrls: ['./icon-bookmark.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconBookmarkComponent {}
